<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{cvCardTitle}}</h4>
          </template>
          <template v-slot:body>
            <p v-show="!propOpenedInModal">{{cvCardSubHeader}}</p>
            <form action="#" v-if="vmGPathCareerUnivScholarshipFormData && Object.keys(vmGPathCareerUnivScholarshipFormData).length > 0">
              <div class="form-row">

                  <div class="col-md-12 mb-3">
                    <label for="validationname">
                      {{cvNameLabel}}</label
                    >
                    <input
                      v-model="vmGPathCareerUnivScholarshipFormData.name"
                      type="text"
                      class="form-control"
                      required
                    />
                </div>
                  <div class="col-md-12 mb-3">
                    <label for="validationdescription">
                      {{cvDescriptionLabel}}</label
                    >
                  <textarea v-model="vmGPathCareerUnivScholarshipFormData.description" type="text" class="form-control" required ></textarea>
                </div>
                  <div class="col-md-12 mb-3">
                    <label for="validationuniv_name">
                      {{cvUnivNameLabel}}</label
                    >
                    <input
                      v-model="vmGPathCareerUnivScholarshipFormData.univ_name"
                      type="text"
                      class="form-control"
                      required
                    />
                </div>
                  <div class="col-md-12 mb-3">
                    <label for="validationcountry">
                      {{cvCountryLabel}}</label
                    >
                    <input
                      v-model="vmGPathCareerUnivScholarshipFormData.country"
                      type="text"
                      class="form-control"
                      required
                    />
                </div>
                  <div class="col-md-12 mb-3">
                    <label for="validationurl">
                      {{cvUrlLabel}}</label
                    >
                    <input
                      v-model="vmGPathCareerUnivScholarshipFormData.url"
                      type="text"
                      class="form-control"
                      required
                    />
                </div>
              </div>
              <div class="form-group">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                   <b-spinner label="Spinning"></b-spinner>
                </button>
                <button type="button" class="btn btn-primary" @click="gpath_career_univ_scholarshipEdit()">{{cvSubmitBtn}}</button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { GPathCareerUnivScholarships } from "../../../FackApi/api/GPathCareerUnivScholarship"
import ApiResponse from "../../../Utils/apiResponse"
import { socialvue } from "../../../config/pluginInit"
import userPermission from "../../../Utils/user_permission.js"

export default {
  name: "GPathCareerUnivScholarshipEdit",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propGPathCareerUnivScholarshipObj: {
      type: Object,
      default: function () {
        return {
          "name": "",
          "description": "",
          "univ_name": "",
          "country": "",
          "url": ""
        }
      }
    }
  },
  data () {
    return {
      apiName: "gpath_career_univ_scholarship_edit",
      cvCardTitle: "Edit gpath_career_univ_scholarship",
      cvCardSubHeader: "Edit gpath_career_univ_scholarship sub header",
      cvSubmitBtn: "Edit",
      cvNameLabel: "name",
      cvDescriptionLabel: "description",
      cvUnivNameLabel: "univ name",
      cvCountryLabel: "country",
      cvUrlLabel: "url",
      showToast: false,
      cvLoadingStatus: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "GPathCareerUnivScholarship Updated",
      vmGPathCareerUnivScholarshipFormData: {}
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  mounted () {
    socialvue.index()
    this.gpath_career_univ_scholarshipView()
  },
  methods: {
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmGPathCareerUnivScholarshipFormData) {
          if (!this.vmGPathCareerUnivScholarshipFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
        return null
      }
    },
    /**
     * gpath_career_univ_scholarshipView
     */
    async gpath_career_univ_scholarshipView () {
      try {
        if (this.propOpenedInModal) {
          this.vmGPathCareerUnivScholarshipFormData = this.propGPathCareerUnivScholarshipObj
        }
        else {
          let gpathCareerUnivScholarshipId = this.$route.params.gcus_id
          let gpathCareerUnivScholarshipViewResp = await GPathCareerUnivScholarships.gpath_career_univ_scholarshipView(this, gpathCareerUnivScholarshipId)

          if (gpathCareerUnivScholarshipViewResp && gpathCareerUnivScholarshipViewResp.resp_status) {
            this.vmGPathCareerUnivScholarshipFormData = gpathCareerUnivScholarshipViewResp.resp_data.data
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_univ_scholarshipView() and Exception:", err.message)
      }
    },
    /**
     * gpath_career_univ_scholarshipEdit
     */
    async gpath_career_univ_scholarshipEdit () {
      try {
        // if (!this.validate()) {
        //   return false
        // }
        this.cvLoadingStatus = true
        let gpathCareerUnivScholarshipAddResp = await GPathCareerUnivScholarships.gpath_career_univ_scholarshipEdit(this, this.vmGPathCareerUnivScholarshipFormData)
        await ApiResponse.responseMessageDisplay(this, gpathCareerUnivScholarshipAddResp)

        if (gpathCareerUnivScholarshipAddResp && !gpathCareerUnivScholarshipAddResp.resp_status) {
          return false
        }

        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseGPathCareerUnivScholarshipEditModal", this.vmGPathCareerUnivScholarshipFormData)
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_univ_scholarshipEdit() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
<style scoped>
textarea {
  min-height: 150px;
  line-height: 27px !important;
}
</style>
